module.exports = __webpack_public_path__ + "img/bg.da8738d8.png";